import {
  SiteRFPDocumentSummariesResponseRecord,
  SiteRFPDocumentSummary,
  SiteRFPPhaseAPIResponse,
} from '@black-bear-energy/black-bear-energy-common'

import { parseNullableEnum } from './parseNullableEnum'

export const transformSiteRFPDocumentSummary = (
  responseElement: SiteRFPDocumentSummariesResponseRecord
): SiteRFPDocumentSummary => {
  const phase = parseNullableEnum(
    responseElement.phase,
    SiteRFPPhaseAPIResponse,
    'phase'
  )
  if (!phase) {
    throw new Error('Unexpected null Site RFP phase')
  }

  return {
    ...responseElement,
    lastUpdated: new Date(responseElement.lastUpdated),
    phase,
    ntpEstimate: responseElement.ntpEstimate
      ? new Date(responseElement.ntpEstimate)
      : null,
  }
}
